module.exports = __webpack_public_path__ + "img/04acage.396ac335.png";